export default __webpack_public_path__ + "static/media/empty-company2.726d6756.png";